<div class="container">
  <app-agricola-toast
    [message]="toastMessage"
    [type]="toastType"
    [show]="showToast"
    (close)="hideToast()">
  </app-agricola-toast>

  <div class="card">
    <app-agricola-stepper
      [steps]="steps"
      [currentStep]="selectedIndex"
      (backClick)="goBack()"
      (stepClick)="goToStep($event)">
    </app-agricola-stepper>

    <h2>Declaratoria</h2>

    <div class="insured-block">
      <div class="info-banner">
        <div class="info-banner-icon">
          <img src="assets/agricola/toast-idea.svg" alt="" aria-hidden="true">
        </div>
        <div class="info-banner-text">
          <span>Recuerda preguntar todas las condiciones al cliente. Si responde 'Sí' a alguna, no se puede emitir la póliza, y el asegurado perderá sus beneficios</span>
        </div>
      </div>

      <div class="declara-card questions-card" [formGroup]="questions">
        <div class="questions-grid">
          <div class="q-field" *ngFor="let question of questionList">
            <app-sis-radio-group
              [legend]="question.label"
              [options]="yesNoOptions"
              [formControlName]="question.controlName"
              [inline]="true">
            </app-sis-radio-group>
          </div>

          <div class="q-field">
            <app-sis-field
              label="Otras enfermedades"
              helper="Help text"
              maxlength="100"
              formControlName="otrasEnfermedades">
            </app-sis-field>
            <span class="char-counter">1/100</span>
          </div>
        </div>
      </div>

      <div class="actions">
        <app-sis-button variant="secondary" (pressed)="goBack()">Cancelar</app-sis-button>
        <app-sis-button [disabled]="hasRiskCondition" (pressed)="goToNextStep($event)">Continuar</app-sis-button>
      </div>
    </div>
  </div>
</div>
